import { Navigate } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { useGetMe } from "@/services/api-hooks/user";

export default function SubscribedRoute({ children }: { children: React.ReactNode }) {
  const { data: user } = useGetMe();
  if (user && user.is_subscribed === false)
    return <Navigate to={ROUTES.PAYWALL("default")} replace />;
  return children;
}
